<template>
    <div class="c-a-input" :class="{ 'c-a-input--invalid': invalid }">
        <label class="c-a-input__label" :for="`question-${id}`">
            {{ label }}
            <span v-if="required">*</span>
        </label>
        <div
            class="c-a-input__wrapper"
            :class="{ 'c-a-input__wrapper--with-icon-left': icon }"
        >
            <icon
                v-if="icon"
                class="c-a-input__icon"
                :icon="icon"
                v-tooltip="{
                    content: `Personnummer kommer skickas till Villaägarna för att färdigställa ert medlemskap`,
                    placement: 'top-center'
                }"
            />

            <input
                type="socialSecurity"
                class="c-a-input__input"
                :placeholder="placeholder"
                :id="`question-${id}`"
                v-model="textValue"
                @input="updated(textValue)"
            />
        </div>
    </div>
</template>

<script>
import Icon from "../AtomIcon.vue";

export default {
    components: {
        Icon
    },
    props: {
        id: Number,
        icon: String,
        label: String,
        invalid: Boolean,
        required: Boolean,
        dataKey: String,
        placeholder: String,
        userInfo: {
            default: "",
            type: String
        }
    },
    data() {
        return {
            textValue: this.userInfo
        };
    },
    methods: {
        updated(newValue) {
            const data = {
                questionId: this.id,
                label: this.label,
                answers: newValue,
                text: true
            };

            if (this.dataKey) {
                data.dataKey = this.dataKey;
            }

            this.$emit("updateData", data);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/request-form/AtomInputSocialSecurityNumber.vue